<template>
  <deletebalior-check
    :pagetitle="`取消委托人审批详情`"
    :snaId="snaId"
  ></deletebalior-check>
</template>

<script>
import DeletebaliorCheck from '@/views/workbench/workCheckManage/baliorCheck/deletebaliorCheck'
import checkMixin from '@/mixin/checkMixin'
import routerMixin from '@/mixin/routerMixin'
export default {
  name: 'deletebaliorCheckDetail',
  mixins: [checkMixin, routerMixin],
  components: { DeletebaliorCheck }
}
</script>

<style scoped></style>
